import React from 'react';
import { Grid, Typography } from '@mui/material';
import SpalshImage from '../../assets/images/splash.png';
import IntlMessages from '../../util/IntlMessages';
import { getVersion } from '../../util/tools';
import config from '../../util/config';
import useStyles from './styles';

function LoadingBackdrop() {
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
      <Grid className={classes.gridImage}>
        <img
          data-testid="img-attribute"
          src={SpalshImage}
          alt={'Pido'}
          className={classes.image}
        />
      </Grid>
      <Grid className={classes.gridVersion}>
        <Typography data-testid="content-version" variant="h6">
          <IntlMessages id="version" /> {getVersion()}
        </Typography>
        <Typography data-testid="content-message" variant="body1">
          <IntlMessages id="privacy" />
        </Typography>
      </Grid>
    </Grid>
  );
}

export default LoadingBackdrop;
